import { COLORS } from '../../constants';
import { Box, Typography } from '@mui/material';
import React from 'react';

interface Props {
    label?: string;
    children?: React.ReactNode;
}

const GroupBox: React.FC<Props> = (props) => {
    const { label, children } = props;

    return (
        <Box
            component="fieldset"
            sx={{ width: 'fit-content', border: `1px solid ${COLORS.GRAY_LIGHT}`, borderRadius: '8px', padding: 4 }}
        >
            {label && (
                <legend>
                    <Typography variant="body1" component="span" sx={{ px: 1 }}>
                        {label}
                    </Typography>
                </legend>
            )}
            {children}
        </Box>
    );
};

export default GroupBox;
